import { render, staticRenderFns } from "./RednessLocations.vue?vue&type=template&id=9574bc6c"
import script from "./RednessLocations.vue?vue&type=script&lang=js"
export * from "./RednessLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports